import { inlineAtomNode } from '#src/tiptap/nodes/shared.ts'

/* A node distinct from insert-current-conditions-button above, not a variant
 * of it. */
export const InsertCurrentConditionsWithNotesButtonNode = inlineAtomNode(
  'insert-current-conditions-with-notes-button',
  'button',
  { display: { isDisplay: true } }
)
